import API from '../../index';

export const APIRoles = {
    get: async () => {
        return await API.get('/roles').then(res => res.data);
    },
};
